<template>
<div class="Data_V_Border">

  <div id="Data_V">
    <div class="Title">
      <img :src="LogoImg" alt="">
      <div> {{ TotalData.planName }} {{ TotalData.sessionName }} </div>
      <div class="Date">
        <span>{{ YMD }}</span>
        <span>{{ HIS }}</span>
      </div>
    </div>

    <!-- Top -->
    <div class="Top">

      <div class="Top_title">
        <div class="title_A"></div>
        <div class="title_B">考情总概</div>
        <div :class="{'dit': TotalData.examStateType == 1, 'dit_B': TotalData.examStateType == 2, 'dit_C': TotalData.examStateType == 3}">
          <div></div>
        </div>
        <div class="title_C" :class="{'c1': TotalData.examStateType == 1, 'c2': TotalData.examStateType == 2, 'c3': TotalData.examStateType == 3}">{{ TotalData.examStateName }}</div>
        <div class="title_D">
          <span v-if="TotalData.examStateType == 1">距考试开始 </span>
          <span v-else-if="TotalData.examStateType == 2">考试已开始 </span>
          <span v-else>考试已结束 </span>
          <span :class="{'c1': TotalData.examStateType == 1, 'c2': TotalData.examStateType == 2, 'c3': TotalData.examStateType == 3}">{{ TotalData.examStateMinute }}</span> 分钟</div>
        <div class="title_E">考试时间：{{ TotalData.beginTime.replace('T', ' ') }} ~ {{ TotalData.endTime.replace('T', ' ') }}</div>
      </div>

      <div class="Top_main">
        <!-- D -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              {{ TotalData.sessionNumber }}
            </span>
            <span>/ {{ TotalData.sessionCount }}</span>
          </div>
          <div class="item_des">
            当前场次
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span>{{ TotalData.courseCount }}</span>
            <span>个</span>
          </div>
          <div class="item_des">
            考试科目
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span>{{ TotalData.placeCount }}</span>
            <span>个</span>
          </div>
          <div class="item_des">
            考点数
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span>{{ TotalData.classRoomCount }}</span>
            <span>个</span>
          </div>
          <div class="item_des">
            考场数
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span> 
              <CountTo :startVal="shouldExamCount.start" :endVal="shouldExamCount.end" :duration="shouldExamCount.duration"></CountTo>
            </span>
            <span>人</span>
          </div>
          <div class="item_des">
            应考人数
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span :style="{'color': TotalData.examStateType == 1 ? '#FFA63E': ''}">
              <CountTo :startVal="signPassCount.start" :endVal="signPassCount.end" :duration="signPassCount.duration"></CountTo>
            </span>
            <span :style="{'color': TotalData.examStateType == 1 ? '#FFA63E': ''}">人</span>
          </div>
          <div class="item_des" :style="{'color': TotalData.examStateType == 1 ? '#FFA63E': ''}">
            签到通过
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span :style="{'color': IsInLoginRange ? '#FFA63E': ''}">
              <CountTo :startVal="loginCount.start" :endVal="loginCount.end" :duration="loginCount.duration"></CountTo>
            </span>
            <span :style="{'color': IsInLoginRange ? '#FFA63E': ''}">人</span>
          </div>
          <div class="item_des" :style="{'color': IsInLoginRange ? '#FFA63E': ''}">
            登录人数
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span :style="{'color': TotalData.examStateType == 2 ? '#FFA63E': ''}">
              <CountTo :startVal="examingCount.start" :endVal="examingCount.end" :duration="examingCount.duration"  ></CountTo>
            </span>
            <span  :style="{'color': TotalData.examStateType == 2 ? '#FFA63E': ''}">人</span>
          </div>
          <div class="item_des" :style="{'color': TotalData.examStateType == 2 ? '#FFA63E': ''}">
            考试中人数
          </div>
        </div>

        <div class="item item_D">
          <div class="item_dule">
            <span :style="{'color': TotalData.examStateType == 3 ? '#FFA63E': ''}">
              <CountTo :startVal="submitCount.start" :endVal="submitCount.end" :duration="submitCount.duration"></CountTo>
            </span>
            <span :style="{'color': TotalData.examStateType == 3 ? '#FFA63E': ''}">人</span>
          </div>
          <div class="item_des" :style="{'color': TotalData.examStateType == 3 ? '#FFA63E': ''}">
            已交卷人数
          </div>
        </div>
      </div>
    </div>

    <div class="DataV_main">
      <!-- Left -->
      <div class="Left">

        <div class="A">
          <div class="title">
            <div>
              <div class="title_A"></div>
              <div class="title_B">签到情况实时统计</div>
            </div>
            <div class="title_C">单位：人</div>
          </div>
          <div class="strate"> 
            <div>
              <div style="background: #266EFF;"></div>
              <span>未签到</span>
            </div>

            <div>
              <div style="background: #EE423D;"></div>
              <span>签到未通过</span>
            </div>

            <div>
              <div style="background: #05C985;"></div>
              <span>签到通过</span>
            </div>
          </div>
          <div id="chart_A"></div>
        </div>

        <div class="B">
          <div class="title" v-if="!isShowScroll">
            <div>
              <div class="title_A"></div>
              <div class="title_B">考点考情实时播报</div>
            </div>
            <div class="title_C">单位：人</div>
          </div>
          <div class="title" v-else>
            <div>
              <div class="title_A"></div>
              <div class="title_B">实时拍照播报</div>
            </div>
          </div>
          <!-- <div class="Scroll" v-show="TotalData.examStateType != 1"> -->
            <div class="Scroll" v-show="!isShowScroll">
            <vueSeamlessScroll :data="data_B_Scroll" class="VueScoll" :class-option="{step: '0.5', limitMoveNum: 5, hoverStop: false}">
              <ul>
                <li
                  v-for="(item, index) in data_B_Scroll"
                  :key="index"
                >
                  <div class="A"> {{ item.spotName }} </div>
                  <div class="B" :style="{ 'color': TotalData.examStateType == 1 ? '#00D86C' : 'rgba(255,255,255,0.85)' }" > 
                    <span :style="{ 'color': TotalData.examStateType == 1 ? '#00D86C' : '#FFF' }" >{{ item.shouldExamCount }}</span> 
                    {{ item.shouldExamText }} 
                  </div>
                  <div class="C" :style="{ 'color': TotalData.examStateType == 2 ? '#00D86C' : 'rgba(255,255,255,0.85)' }" > 
                    <span :style="{ 'color': TotalData.examStateType == 2 ? '#00D86C' : '#FFF' }" >{{ item.examingCount }}</span> 
                    {{ item.examingText }} 
                  </div>
                  <div class="D" :style="{ 'color': TotalData.examStateType == 3 ? '#00D86C' : 'rgba(255,255,255,0.85)' }" > 
                    <span :style="{ 'color': TotalData.examStateType == 3 ? '#00D86C' : '#FFF' }" >{{ item.submitCount }}</span>
                    {{ item.submitText}} 
                  </div>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>

          <!-- <div class="Scroll" v-show="TotalData.examStateType == 1"> -->
          <div class="Scroll" v-show="isShowScroll">
            <vueSeamlessScroll :data="ScrollList" class="VueScoll" :class-option="{step: '0.5', limitMoveNum: 3, hoverStop: false}">
              <ul class="ImgScroll">
                <li
                  v-for="(item, index) in ScrollList"
                  :key="index"
                >
                  <div v-for="(value, key) in item" :key="key">
                    <img :src="value.signPhoto" alt="">
                    <div>
                      <div :style="{'background': value.signState == 1 ? '#00D86C' : '#EE423D'}"></div>
                      <div>{{ value.placeName }}</div>
                    </div>
                  </div>
                </li> 
              </ul>
            </vueSeamlessScroll>
          </div>

        </div>
      </div>

      <!-- Center -->
      <div class="Center">

        <div class="A">
          <div class="title">
            <div>
              <div class="title_A"></div>
              <div class="title_B">考情统计</div>
            </div>
          </div>

          <div class="charts">
            <!-- 饼图区域 -->
            <div class="chart_C" v-show="!showCourseList">
              <div class="chart_Border_C">
                <div id="chart_C_ID"></div>
              </div>
              <div class="info_Mob">
                <div class="dit"></div>
                <span>参考</span>
                <span class="number"> {{ TotalData.examedCount }} </span>
                <span>人</span>
              </div>
              <div class="info_Web">
                <div class="dit"></div>
                <span>缺考</span>
                <span class="number"> {{ TotalData.unExamCount }} </span>
                <span>人</span>
              </div>
            </div>
            <div class="chart_D" v-show="!showCourseList">
              <div class="chart_Border_D">
                <div id="chart_D_ID"></div>
              </div>
              <div class="info_Mob">
                <div class="dit"></div>
                <span>异常</span>
                <span class="number"> {{ TotalData.unusualCount }} </span>
                <span>人</span>
              </div>
              <div class="info_Web">
                <div class="dit"></div>
                <span>正常</span>
                <span class="number"> {{ TotalData.usualCount }} </span>
                <span>人</span>
              </div>
            </div>
            <!-- 课程列表区域 -->
            <div class="courseList" v-show="showCourseList">
              <div class="course-item" v-for="(group, groupIndex) in courseGroupListSub" :key="groupIndex">
                <div class="course-row" v-for="(course, courseIndex) in group" :key="courseIndex">
                  <div class="course-name">{{ course.courseName }}</div>
                  <div class="course-data">
                    <div class="data-row examed-row">
                      <span class="label" style="width: 30%;">缺考：<span class="unexamed">{{ course.unexamed }}人</span></span>
                      <span class="label" style="width: 30%;">实考：<span class="examed">{{ course.examed }}人</span></span>
                      <span class="label" style="width: 40%;">参考率：<span class="percent">{{ course.examedPercent }}</span></span>
                    </div>
                    <div class="data-row abnormal-row">
                      <span class="label" style="width: 30%;">正常：<span class="normal">{{ course.examed4normal }}人</span></span>
                      <span class="label" style="width: 30%;">异常：<span class="abnormal">{{ course.examed4abnormal }}人</span></span>
                      <span class="label" style="width: 40%;">异常率：<span class="percent">{{ course.abnormalPercent }}</span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="B">
          <div class="title">
            <div>
              <div class="title_A"></div>
              <div class="title_B">考试实时并发趋势图</div>
            </div>
          </div>
          <div id="chart_B"></div>
        </div>
      </div>

      <!-- Right -->
      <div class="Right">
        <!-- 作答情况 -->
        <div class="A">
          <div class="title">
            <div>
              <div class="title_A"></div>
              <div class="title_B">作答情况</div>
            </div>
          </div>
          <div class="chart_E">
            <div id="chart_E"></div>
            <div class="des">
              <div class="des_item">
                <div class="dit"></div>
                <div class="des_step">作答中</div>
                <div class="des_num"><span>{{ TotalData.examingCount }} </span>人</div>
              </div>
              <div class="des_item">
                <div class="dit"></div>
                <div class="des_step">已交卷</div>
                <div class="des_num"><span>{{ TotalData.submitCount }} </span>人</div>
              </div>
              <div class="des_item">
                <div class="dit"></div>
                <div class="des_step">强制交卷</div>
                <div class="des_num"><span>{{ TotalData.forceSubmitCount }} </span>人</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 考试科目分布 -->
        <div class="B" style="display: flex;" v-show="data_F.length < 7">
          <div class="title">
            <div>
              <div class="title_A"></div>
              <div class="title_B">考试科目分布</div>
            </div>
          </div>
          <div class="charts">
            <div id="chart_F"></div>
          </div>
          <div class="charts_desc" v-if="data_F_List.length < 7">
            <ul>
              <li v-for="(item, index) in data_F_List" :key="index">
                <div :style="{'background': colorList[index]}"></div>
                <span style="font-size: .07rem;" class="itemA">{{ item.name }}</span>
                <span style="font-size: .09rem; margin-left: .04rem; width: auto;" class="itemB">{{ item.value }}</span>
                <span style="font-size: .07rem; margin-left: .04rem;" class="itemC">人</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 考试科目分布 -->
        <div class="C" v-show="data_F.length > 6" style="height: calc(26/78 * 100%);">
          <div class="title">
            <div>
              <div class="title_A"></div>
              <div class="title_B">考试科目分布</div>
            </div>
          </div>
          <div id="chart_H" style="width: 100%; height: 100%; padding-top: .16rem; box-sizing: border-box;"></div>
        </div>
        <!-- 考生IP地址分布 -->
        <div class="C">
          <div class="title" style="white-space: nowrap;text-overflow: ellipsis;">
            <div>
              <div class="title_A"></div>
              <div class="title_B">考生IP地址分布 <span v-show="data_G.length == 0">（ {{ data_G.length > 0 ? data_G[data_G_Number].placeName : '暂无考点' }} ）</span></div>
            </div>
            <div class="title_C">单位：人次</div>
          </div>
          <div id="chart_G"></div>
        </div>

      </div>
    </div>

  </div>

</div>

</template>

<script>
import CountTo from 'vue-count-to'
import vueSeamlessScroll from "vue-seamless-scroll";
import { queryTotalDataApi, querySignCountApi, queryPhotoListApi, querySpotCountApi, queryCourseCountApi,queryCourseCountDetailApi, queryExamIpAddressApi, querySessionNextApi, queryDatetimeCountApi } from '@/http/modules/dataV.js';

export default {
  components: {
    CountTo,
    vueSeamlessScroll
  },
  computed: {
    isShowScroll(){
      if (this.ScrollList.length > 0) {
        return this.TotalData.examStateType == 1
      } else {
        return false;
      }
    }
  },
  watch: {
    'TitleInfo.planId': 'initECharts',
  },
  data() {
    return {
      // Logo
      LogoImg: require("@/assets/img/customDefault.png"),   
      // Date
      YMD: '',
      HIS: '',
      // 部分接口使用的公共参数
      TitleInfo: {
        id: this.$route.query.sessionId,
        planId: this.$route.query.planId,
      },
      // 是否显示课程统计数据（从路由参数传入）
      showCourseStat: false,
      // 考情总概相关数据
      TotalData: {
        beginTime: '',        // 开始时间
        endTime: '',          // 结束时间
        examStateName: '',    // 考试阶段描述
        planName: '',         // 批次名称
        sessionName: '',      // 场次名称
        sessionNumber: '',    // 当前场次
        sessionCount: '',     // 总场次
        examStateType: '',    // 对应"考试阶段描述": 距考试(1),考试中(2)已结束(3)
        examStateMinute: '',  // 对应"考试阶段描述"已进行时间
        courseCount: '',      // 考试科目数量
        placeCount: '',       // 考点数量
        classRoomCount: '',   // 考场数量
        shouldExamCount: '',  // 应考人数
        signPassCount: '',    // 签到人数
        loginCount: '',       // 签到人数
        examingCount: '',     // 考中人数
        submitCount: '',      // 交卷人数
      },
      // 应考人数
      shouldExamCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 签到人数
      signPassCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 登录人数
      loginCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 登录人数颜色设置 (判断时间是否在考试时间范围内)
      IsInLoginRange: false,
      // 考中人数
      examingCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 已交卷人数
      submitCount: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 用于判断大屏是否为首次加载
      start_ECharts: true,
      // "签到情况实时统计" 相关数据
      data_A: [],
      data_A_Index: 0,
      // "实时考情" 相关数据
      data_B: [],
      data_B_Index: 0,
      data_B_Scroll: [],
      data_B_flag: [],
      data_B_ImgList: [],
      // "考试科目分布" 相关数据
      data_F: [],
      data_F_List: [],
      // "考生IP分布" 相关数据
      data_G: [
        {
          placeName: "",
          screenExamIpCountList: []
        }
      ],
      data_G_Number: 0,
      // "考生科目分布" 相关数据
      chart_H_Index: 0,
      // 大屏定时器存储
      timer_Int: '',
      timer_ps: '',
      Interval_B: '',
      Interval_A: '',
      Interval_C: '',
      Interval_D: '',
      Interval_E: '',
      Interval_F: '',
      Interval_G: '',
      Interval_H: '',
      ImageTimer: '',
      // 前端配置的"年月日时分秒"
      currentTime: '',
      // 实时拍照滚动数据
      ScrollList: [],
      // 考试科目分布数据是否为空
      charts_F_isNull: false,
      // 实时考情图标描述
      chart_B_desc: '',
      // 色块
      colorList: ['#023AFF', '#FFA63E', '#00D86C', '#7300E6', '#EE423D', '#266EFF'],
      // 并发数据
      Concurrency: [],
      // 课程详细数据
      courseDetailList: [],
      // 课程分组列表（每 2 门课一组）
      courseGroupList: [],
      // 课程分组列表（每 2 门课一组）
      courseGroupListSub: [],
      // 课程轮播索引
      courseBroadcastIndex: 0,
      // 是否显示课程列表
      showCourseList: false,
      // 课程轮播定时器
      courseBroadcastTimer: null,
      // 上一次课程列表的 JSON 字符串（用于判断数据是否变化）
      lastCourseListJson: '',
      // ECharts 实例引用（避免重复销毁和重建）
      chart_C_instance: null,
      chart_D_instance: null,
    }
  },
  
  methods: {
    /**
     * @param { Logo }
     */
    getCustomSet(){
      let tenant = window.localStorage.getItem('tenant')
      let defaultLogo = require("@/assets/img/customDefault.png")
      this.$api.system.getSystemNameFN({tenant}).then(({data})=>{
        this.LogoImg = data.isUsedLogo == 1 ? data.logoUrl ? data.logoUrl : defaultLogo : defaultLogo
      })
    },

    /**
     * @param { 时间 YMD-HIS }
     */
    currentDate() {
      let that = this
      let nowTime = function() {
        that.YMD = current_YMD()
        that.HIS = current_HIS()
      }
      function twoDigits (val) {
        if (val < 10) return '0' + val
        return val
      }
      function current_YMD() {
        let date = new Date()
        let YMD = date.getFullYear() + '年' + twoDigits(date.getMonth() + 1) + '月' + twoDigits(date.getDate()) + '日'
        return YMD
      }
      function current_HIS() {
        let date = new Date()
        let HIS = twoDigits(date.getHours()) + ':' + twoDigits(date.getMinutes()) + ':' + twoDigits(date.getSeconds())
        return HIS
      }
      this.currentTime = setInterval(nowTime, 1000)
    },

    /**
     * @param { 数字格式 }
     */
    setNumber(p, i) {
      let value = ''
      if (p.value[i] >= 0) {
        value = p.value[i]
        if (value > 999) {
          let parts = value.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          value = parts.join('.')
        }
      }
      return value
    },

    /**
     * @param { 柱状图样式 }
     */
    itemStyle(color) {
      return  {
          normal: {
            barBorderRadius: [2, 2, 0, 0],
            color,
            label: {
              position: 'top',
              show: true,
              color: 'rgba(255, 255, 255, 0.85)'
            }
          },
        }
    },

    /**
     * @param { E-charts }
     */
    async DrawECharts() {
      await this.chart_A();
      await this.chart_B();
      await this.chart_C();
      await this.chart_D();
      await this.chart_E();
      await this.chart_F();
      await this.chart_G();
      await this.chart_H();
    },

    /**
     * @param { 签到情况实时统计  Left => Top }
     */
    chart_A() {
      let that = this

      // Option 数据处理
      let Option_data = function (i) {
        let data = []
        that.data_A[i].map(e=>{
          let item = [e.placeName, e.unsignCount, e.unpassCount, e.passCount]
          data.push(item)
        })
        return data
      }

      // Option
      let myChart = this.$echarts.init(document.getElementById("chart_A"))
      var option = {
        grid: {
          x: 48,
          x2: 52,
          y2: 60,
        },
        dataset: {
          source: Option_data(0)
        },
        xAxis: { 
          type: 'category',
          axisLabel: {
            margin: 18,
            padding: [0, 0 , 0, -16],
            rotate: -20,
          },
        },
        yAxis: {
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
            }
          }
        },
        series: [
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 1) }
              }
            },
            type: 'bar', 
            barWidth: '14.3%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#023AFF')
          }, 
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 2) }
              }
            },
            type: 'bar',
            barWidth: '14.3%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#EE423D'),
          }, 
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 3) }
              }
            },
            type: 'bar',
            barWidth: '14.3%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#05C985')
          }
        ],
      }
      option && myChart.setOption(option)

      // setInterval
      clearInterval(this.Interval_A)
      this.Interval_A = setInterval(() => {
        that.data_A_Index++
        if (that.data_A_Index > that.data_A.length - 1) {
          that.data_A_Index = 0
        }
        clearTimeout(timer_A)
        let timer_A = setTimeout(() => {
          document.getElementById('chart_A').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_A"))
          option.dataset.source = Option_data(that.data_A_Index)
          myChart.setOption(option)
        }, 1000)
      }, 30000)
    },

    /**
     * @param { 实时考情 Left => Bottom }
     */
    chart_B() {
      let that = this;
      let signList = [];
      let submitList = [];
      let answerList = [];
      let x_Data = [];

      this.Concurrency.map(e=>{
        signList.push(e.signedCount);
        submitList.push(e.submitCount);
        answerList.push(e.answerCount);
        x_Data.push(e.time);
      })

      let myChart = this.$echarts.init(document.getElementById("chart_B"))

      var option = {
        grid: {
          x: 48,
          x2: 52,
          y2: 24,
          y1: 120
        },
        legend: {
          origin: "horizontal",
          top: "top",
          left: "center",
          itemGap: 16,
          textStyle: {
            fontSize: 14,
            color: "#A3A7BF"
          },
          padding: [16, 0, 0, 0]
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: x_Data
        },
        yAxis: [
          {
          type: 'value',
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
            }
          },
        },{
          type: 'value',
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
            }
          },
        }
        ],
        series: [
          {
            name: "签到人数",
            data: signList,
            type: 'line',
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#FFF",
                borderColor: "#00D86C",
                borderWidth: 1,
              }
            },
            lineStyle: {
              color: "#00D86C",
            }
          },
          {
            name: "进入考试",
            data: answerList,
            yAxisIndex: 1,
            type: 'line',
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#FFF",
                borderColor: "#3366FF",
                borderWidth: 1,
              }
            },
            lineStyle: {
              color: "#3366FF",
            }
          },
          {
            name: "交卷人数",
            data: submitList,
            type: 'line',
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#FFF",
                borderColor: "#FFA63E",
                borderWidth: 1,
              }
            },
            lineStyle: {
              color: "#FFA63E",
            }
          },
        ]
      };

      option && myChart.setOption(option)

      clearInterval(this.interval_B)
      this.interval_B = setInterval(() => {
        clearTimeout(timer)
        let timer = setTimeout(function(){
          document.getElementById('chart_B').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_B"))

          // 参数处理
          let signList = [];
          let submitList = [];
          let answerList = [];
          let x_Data = [];

          that.Concurrency.map(e=>{
            signList.push(e.signedCount);
            submitList.push(e.submitCount);
            answerList.push(e.answerCount);
            x_Data.push(e.time);
          })

          option.xAxis.data = x_Data;
          option.series[0].data = signList;
          option.series[1].data = answerList;
          option.series[2].data = submitList;

          option && myChart.setOption(option)
        }, 2000)
      }, 60000)

      return;
      // Option 数据
      let Option_data = function(i) {
        let data = []
        if (!that.data_B_flag) {
          that.data_B[i].map(e=>{
            e.spotName = e.spotName.length > 8 ? e.spotName.slice(0, 8) + '...' : e.spotName
            let item = [e.spotName, e.shouldExamCount, e.examingCount, e.submitCount]
            data.push(item)
          })
        }
        return data
      }
      var option = {
        grid: {
          x: 48,
          x2: 52,
          // y: 108,
          y2: 60,
        },
        dataset: {
          source: Option_data(0)
        },
        xAxis: {
          type: 'category', 
          nameLocation: 'right',
          axisLabel: {
            margin: 18,
            padding: [0, 0 , 0, -16],
            rotate: -20,
          },
        },
        yAxis: {
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
            }
          }
        },
        series: [
          {
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 1) }
              }
            },
            type: 'bar', 
            barWidth: '14.3%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#05C985')
          }, 
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 2) }
              }
            },
            type: 'bar',
            barWidth: '14.3%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#023AFF')
          }, 
          { 
            label: {
              normal: {
                formatter: (p) => { return that.setNumber (p, 3) }
              }
            },
            type: 'bar',
            barWidth: '14.3%',
            barMinHeight: 2,
            itemStyle: that.itemStyle('#FFA63E')
          }
        ],
      }
      option && myChart.setOption(option)

      clearInterval(this.Interval_B)
      this.Interval_B = setInterval(() => {
        that.data_B_Index++
        if (that.data_B_Index > that.data_B.length - 1) {
          that.data_B_Index = 0
        }

        clearTimeout(timer_B)
        let timer_B = setTimeout(() => {
          document.getElementById('chart_B').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_B"))

          option.dataset.source = Option_data(that.data_B_Index)
          myChart.setOption(option)  
        }, 1000)
      }, 30000)
    },

    /**
     * @param { 考情统计 Center => Top => Left }
     */
    chart_C() {
      let that = this

      // 销毁旧实例
      if (this.chart_C_instance) {
        this.chart_C_instance.dispose()
        this.chart_C_instance = null
      }

      let data = [
        { value: this.TotalData.examedCount},
        { value: this.TotalData.unExamCount}
      ]

      let myChart = this.$echarts.init(document.getElementById("chart_C_ID"))
      this.chart_C_instance = myChart

      let option = {
        series: [
          {
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|${this.TotalData.examPercent}\n参考率}`,
              rich: {
                total: {
                  fontSize: 14,
                  lineHeight: 16,
                  fontWeight: 500,
                  color: "#FFF",
                  fontFamily: 'PingFangSC-Regular, PingFang SC'
                }
              },
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#00CC88', '#FFA63E']
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data,
          }
        ]
      }
      option && myChart.setOption(option)

      // setInterval - 只刷新数据，不重建实例
      clearInterval(this.Interval_C)
      this.Interval_C = setInterval(() => {
        let data = [
          { value: that.TotalData.examedCount},
          { value: that.TotalData.unExamCount}
        ]
        option.series[0].label.formatter = `{total|${that.TotalData.examPercent}\n参考率 }`
        option.series[0].data = data
        if (that.chart_C_instance) {
          that.chart_C_instance.setOption(option)
        }
      }, 60000)
    },

    /**
     * @param { 考情统计 Center => Top => Right}
     */
    chart_D() {
      let that = this

      // 销毁旧实例
      if (this.chart_D_instance) {
        this.chart_D_instance.dispose()
        this.chart_D_instance = null
      }

      let data = [
        { value: this.TotalData.unusualCount },
        { value: this.TotalData.usualCount }
      ]

      let myChart = this.$echarts.init(document.getElementById("chart_D_ID"))
      this.chart_D_instance = myChart

      let option = {
        series: [
          {
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|${this.TotalData.unusualPercent}\n异常率 }`,
              rich: {
                total: {
                  color: "#FFF",
                  fontSize: 14,
                  lineHeight: 16,
                  fontWeight: 500,
                  fontFamily: 'PingFangSC-Regular, PingFang SC'
                }
              },
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#EE423D', '#00CC88']
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data,
          }
        ]
      }
      option && myChart.setOption(option)

      // setInterval - 只刷新数据，不重建实例
      clearInterval(this.Interval_D)
      this.Interval_D = setInterval(() => {
        let data = [
          { value: that.TotalData.unusualCount },
          { value: that.TotalData.usualCount }
        ]
        option.series[0].label.formatter = `{total|${that.TotalData.unusualPercent}\n异常率 }`
        option.series[0].data = data
        if (that.chart_D_instance) {
          that.chart_D_instance.setOption(option)
        }
      }, 60000)
    },

    /**
     * @param { 考情统计 - 课程列表轮播 }
     */
    initCourseBroadcast() {
      // 清除之前的定时器
      if (this.courseBroadcastTimer) {
        clearInterval(this.courseBroadcastTimer)
        this.courseBroadcastTimer = null
      }

      // 如果只有 1 门课，不显示课程列表，只显示饼图（情况三）
      if (this.courseDetailList.length <= 1) {
        this.showCourseList = false
        return
      }

      // 每 2 门课分组
      const groupCourses = (courses) => {
        const groups = []
        for (let i = 0; i < courses.length; i += 2) {
          groups.push(courses.slice(i, i + 2))
        }
        return groups
      }

      this.courseGroupList = groupCourses(this.courseDetailList)
      const totalGroups = this.courseGroupList.length

      // 启动统一轮播：先显示饼图 5 秒，然后显示课程列表
      this.startBroadcastCycle(totalGroups)
    },

    /**
     * @param { 考情统计 - 课程轮播周期（统一计时器） }
     */
    startBroadcastCycle(totalGroups) {
      let that = this

      // 清除之前的定时器
      if (this.courseBroadcastTimer) {
        clearInterval(this.courseBroadcastTimer)
        this.courseBroadcastTimer = null
      }

      // 先显示饼图 5 秒
      this.showCourseList = false

      // 情况二：只有 2 门课（1 组）
      if (totalGroups === 1) {
        // 10 秒后开始切换
        setTimeout(() => {
          that.courseBroadcastTimer = setInterval(() => {
            // 切换显示状态
            that.showCourseList = !that.showCourseList
            if (that.showCourseList) {
              // 显示课程列表
              that.courseGroupListSub = [that.courseGroupList[0]]
            } else {
              // 切换回饼图，调用 resize 确保尺寸正确
              that.$nextTick(() => {
                if (that.chart_C_instance) that.chart_C_instance.resize()
                if (that.chart_D_instance) that.chart_D_instance.resize()
              })
            }
            // 每 10 秒切换一次
          }, 10000)
        }, 10000)
      }
      // 情况一：大于 2 门课（多组）
      else {
        // 使用实例属性存储索引，避免闭包问题
        this.courseBroadcastIndex = 0
        // 10 秒后开始轮播课程
        setTimeout(() => {
          that.courseBroadcastTimer = setInterval(() => {
            // 显示课程列表
            that.showCourseList = true
            that.courseGroupListSub = [that.courseGroupList[that.courseBroadcastIndex]]

            if (that.courseBroadcastIndex >= totalGroups) {
              // 课程轮播完毕，回到饼图
              that.courseBroadcastIndex = 0
              that.showCourseList = false
              // 切换回饼图，调用 resize 确保尺寸正确
              that.$nextTick(() => {
                if (that.chart_C_instance) that.chart_C_instance.resize()
                if (that.chart_D_instance) that.chart_D_instance.resize()
              })
            } else {
              // 移动到下一组
              that.courseBroadcastIndex++
            }
            // 每 10 秒切换一次
          }, 10000)
        }, 10000)
      }
    },

    /**
     * @param { 作答情况 Right => Top }
     */
    chart_E() {
      let that = this

      let data1 = [
        {value: this.TotalData.submitCount },
        {value: this.TotalData.examingCount },
      ]
      let data2 = [
        { value: this.TotalData.forceSubmitCount },
        { value: this.TotalData.examingCount + this.TotalData.submitCount - that.TotalData.forceSubmitCount }
      ]

      let myChart = this.$echarts.init(document.getElementById("chart_E"))
      var option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = that.TotalData.examStateType == 1 ? ['#00134D','#00CC88', '#023AFF'] : ['#00CC88', '#023AFF']
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data:  that.TotalData.examStateType == 1 ? [{value: 0}] : [...data1],
          },
          {
            type: 'pie',
            radius: ['70%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = that.TotalData.examStateType == 1 ? ['#142373', '#EE423D', '#142373'] : ['#EE423D', '#142373']
                  return list[colors.dataIndex]
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: that.TotalData.examStateType == 1 ? [{value: 0}] : [...data2],
          }
        ]
      }
      option && myChart.setOption(option)

      // setInterval
      clearInterval(this.Interval_E)
      this.Interval_E = setInterval(() => {

        clearTimeout(timer_E)
        let timer_E = setTimeout(() => {
          document.getElementById('chart_E').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_E"))

          let data1 = [
            {value: that.TotalData.submitCount },
            {value: that.TotalData.examingCount },
          ]
          let data2 = [
            { value: that.TotalData.forceSubmitCount },
            { value: that.TotalData.examingCount + that.TotalData.submitCount - that.TotalData.forceSubmitCount }
          ]
          option.series[0].data = that.TotalData.examStateType == 1 ? [{value: 0}] : [...data1],
          option.series[1].data = that.TotalData.examStateType == 1 ? [{value: 0}] : [...data2],
          myChart.setOption(option)          
        }, 7000)
      }, 60000)
    },

    /**
     * @param { 考试科目分布 Right => Center}
     */
    chart_F() {
      let myChart = this.$echarts.init(document.getElementById("chart_F"))
      var option
      let _this = this

      // (1) 考试科目 E-charts 数据
      let data = []
      this.data_F.map(e=>{
        let item = { value: e.value}
        data.push(item);
      })
      // (2) 无科目数据处理
      if (data.length == 0) {
        this.charts_F_isNull = true
        data = [{value: 0}]
      }

      option = {
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '100%',
            data,
            hoverAnimation: false,
            label: {
              normal: {
                show: false
              },
              formatter: this.charts_F_isNull ? '' : '{name|{b}}\n{value|{c}} {default|人}',
              minMargin: 5,
              edgeDistance: 4,
              lineHeight: 15,
              rich: {
                name: {
                  fontSize: 14,
                  color: '#FFF',
                  lineHeight: 24,
                },
                value: {
                  fontSize: 18,
                  color: '#FFF',
                  lineHeight: 24,
                },
                default: {
                  fontSize: 14,
                  color: '#FFF',
                  lineHeight: 24,
                }
              }
            },
            labelLine: {
              length: this.charts_F_isNull ? 0: 15,
              length2: this.charts_F_isNull ? 0: 15,
              normal: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = _this.charts_F_isNull ? ['#00134D'] : _this.colorList
                  return list[colors.dataIndex]
                }
              }
            },
          }
        ]
      }
      option && myChart.setOption(option)

      // setInterval
      let that = this
      clearInterval(this.Interval_F)
      this.Interval_F = setInterval(() => {
        clearTimeout(timer_F)
        let timer_F = setTimeout(() => {

          document.getElementById('chart_F').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_F"))

          let data = []
          that.data_F.map(e=>{
            let item = { value: e.value}
            data.push(item);
          })
          if (data.length == 0) {
            that.charts_F_isNull = true
            data = [{value: 0}]
          } else {
            that.charts_F_isNull = false
          }
          option.series[0].data = data
          myChart.setOption(option)
        }, 7000)
      }, 60000)
    },

    /**
     * @param { 考试科目分布 Right => Center}
     */
    chart_H() {
      let myChart = this.$echarts.init(document.getElementById("chart_H"))
      var option

      let xData = []
      let yData = []

      const division = (arr, num) => {
          let newArr = []
          return arr.reduce(function(pre, item, index, arr){
              var begin = index * num
              var end = begin + num
              var res = arr.slice(begin, end)
              if (res.length != 0) {
                newArr[index] = res
              }
              return newArr
          }, [])
      }

      let data = division(this.data_F, 4)
      this.chart_H_Index = 0

      data[0].map(e=>{
        let item = {...e}
        item.name = item.name.length > 6 ? item.name.slice(0, 6) + '...' : item.name
        xData.push(item.name)
        yData.push(item.value)
      })

      option = {
        grid: {
          x: 48,
          x2: 52,
          y2: 48,
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            margin: 18,
            padding: [0, 0 , 0, -16],
            rotate: -15,
          },
        },
        yAxis: {
          splitNumber: 3,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            data: yData,
            type: 'bar',
            barWidth: "13.4%",
            barMinHeight: 2,
            itemStyle: {
              normal: {
                barBorderRadius: [6, 6, 6, 6],
                color: '#FFA63E',
                label: {
                  formatter: function(p) {
                    let value = ''
                    if (p.value >= 0) {
                      value = p.value
                      if (value > 999) {
                        let parts = value.toString().split('.')
                        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        value = parts.join('.')
                      }
                    }
                    return value
                  },
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)'
                },
              },
            },
          }
        ]
      }

      setTimeout(() => {
        option && myChart.setOption(option)
      }, 500)

      let that = this
      clearInterval(this.Interval_H)
      this.Interval_H = setInterval(() => {
        clearTimeout(timer_F)
        let timer_F = setTimeout(() => {
          document.getElementById('chart_H').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_H"))

          let data = division(that.data_F, 4)

          that.chart_H_Index++
          if (that.chart_H_Index > (data.length - 1)) {
            that.chart_H_Index = 0
          }

          let xData = []
          let yData = []

          data[that.chart_H_Index].map(e=>{
            let item = {...e}
            item.name = item.name.length > 6 ? item.name.slice(0, 6) + '...' : item.name
            xData.push(item.name)
            yData.push(item.value)
          })

          option.xAxis.data = xData
          option.series[0].data = yData
          
          option & myChart.setOption(option)
        }, 500)
      }, 5000)
    },

    /**
     * @param { 考生IP地址分布 Right => Bottom}
     */    
    chart_G() {
      let myChart = this.$echarts.init(document.getElementById("chart_G"));
      var option;

      let xData = ['IP1', 'IP2', 'IP3', 'IP4', 'IP5', 'IP6']
      let yData = []

      this.data_G[0].screenExamIpCountList.map(e=>{
        yData.push(e.ipCount)
      })

      option = {
        grid: {
          x: 48,
          x2: 52,
          y2: 32,
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: {
          splitNumber: 3,
          type: 'value',
          // 横向网格线颜色
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            data: yData,
            type: 'bar',
            barWidth: "13.4%",
            itemStyle: {
              normal: {
                barBorderRadius: [6, 6, 6, 6],
                color: '#1966FF',
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)'
                }
              },
            }
          }
        ]
      }
      option && myChart.setOption(option);

      let that = this
      clearInterval(this.Interval_G)
      let timeList = this.data_G.map(e=>{
        return e.short ? 3000 : 10000
      })
      let timeIndex = 0
      function fn() {
        clearTimeout(timer_G)
        let currentTime = timeList[timeIndex]
        let timer_G = setTimeout(() => {

          document.getElementById('chart_G').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_G"))

          that.data_G_Number++
          if (that.data_G_Number == that.data_G.length) {
            that.data_G_Number = 0
          }
          let xData = ['IP1', 'IP2', 'IP3', 'IP4', 'IP5', 'IP6']
          let yData = []
          that.data_G[that.data_G_Number].screenExamIpCountList.map(e=>{
            yData.push(e.ipCount)
          })  
          option.xAxis.data = xData
          option.series[0].data = yData
          myChart.setOption(option)
        }, 500)
        timeIndex++
        if (timeIndex > timeList.length -1) {
          timeIndex = 0
        }
        if (currentTime != timeList[timeIndex]) {
          clearInterval(that.Interval_G)
          that.Interval_G = setInterval(fn, timeList[timeIndex])
        }
      }
      this.Interval_G = setInterval(fn, timeList[timeIndex])
    },

    /**
     * @param { Top_Banner 考试信息 }
     */
    async getPlanSession() {
      // 标题
      let nextInfo = await querySessionNextApi({ planId: this.TitleInfo.planId, sessionId: this.TitleInfo.id });
      if (nextInfo.data.toNext == 1 && nextInfo.code == 1) {
        this.TitleInfo.id = nextInfo.data.sessionId;
      }

      // 翻牌器数字初始化
      this.shouldExamCount.end = 0
      this.signPassCount.end = 0
      this.loginCount.end = 0
      this.examingCount.end = 0
      this.submitCount.end = 0

      // 查询总计数据
      let res = await queryTotalDataApi({ planId: this.TitleInfo.planId, sessionId: this.TitleInfo.id })
      this.TotalData = { ...res.data }

      // 登录中人数颜色配置
      let currentTime = Date.now()
      let beginTime = Date.parse(res.data.beginTime)
      this.IsInLoginRange = (currentTime > beginTime) && (currentTime < (beginTime + 1800000))

      // 应考
      this.shouldExamCount.start = this.shouldExamCount.end
      this.shouldExamCount.end = this.TotalData.shouldExamCount

      // 签到
      this.signPassCount.start = this.signPassCount.end
      this.signPassCount.end = this.TotalData.signPassCount

      // 登录中
      this.loginCount.start = this.loginCount.end
      this.loginCount.end = this.TotalData.loginCount

      // 考中
      this.examingCount.start = this.examingCount.end
      this.examingCount.end = this.TotalData.examingCount

      // 交卷
      this.submitCount.start = this.submitCount.end
      this.submitCount.end = this.TotalData.submitCount
    },

    /**
     * @param { E-charts 图表数据处理 }
     */
    async initECharts() {
      // 数组类型转换
      const division = (arr, num) => {
        let newArr = []
        return arr.reduce(function(pre, item, index, arr){
          var begin = index * num
          var end = begin + num
          var res = arr.slice(begin, end)
          if (res.length != 0) {
            newArr[index] = res
          }
          return newArr
        }, [])
      }

      // E-charts 图表数据请求参数
      let param = {
        planId:  this.TitleInfo.planId,
        sessionId: this.TitleInfo.id
      }

      // Chart_A 图表数据
      this.data_A = []
      let { data } = await querySignCountApi(param)
      this.data_A = data
      this.data_A.map(e=>{
        e.placeName = e.placeName.length > 8 ? e.placeName.slice(0, 8) + '...': e.placeName
      })
      this.data_A = division(this.data_A, 5)

      // Chart_B 图表数据
      let photoList = await queryPhotoListApi(param)
      let spotList = await querySpotCountApi(param)
      if (spotList.data.length > 0) {
        if (spotList.data[0].shouldExamText == '人报考') {
          this.chart_B_desc = '已报考'
        } else {
          this.chart_B_desc = '签到通过'
        }
      } else {
        this.chart_B_desc = '签到通过'
      }

      // 并发折线图数据
      let Concurrency = await queryDatetimeCountApi(param);
      this.Concurrency = Concurrency.data;


      // 考试结束 ==> 考点考情不滚动
      if (this.TotalData.examStateType == '3') {
        this.data_B_Scroll = spotList.data.slice(-4);
      } else {
        this.data_B_Scroll = spotList.data;
      }

      if (!photoList.data) {
        this.data_B = spotList.data
        this.data_B_flag = false
        this.data_B = division(this.data_B, 5)
      } else {
        photoList.data.map(e=>{
          if (e.placeName.length > 8) {
            e.placeName = e.placeName.substr(e.placeName.length - 8, 8);
          }
        })
        this.data_B = photoList.data;
        this.data_B_flag = true;
        let len = photoList.data.length;
        let newList = []
        if (len) {
          var chunk = 4
          for (var i = 0, j = len; i < j; i += chunk) {
            newList.push(photoList.data.slice(i, i + chunk))
          }
        }
        this.data_B_ImgList = [...newList]
      }

      // Chart_F 图表数据
      let CourseList = await queryCourseCountApi(param)

      this.data_F = []
      this.data_F_List = []
      for (let key in CourseList.data) {
        let item = {'value': CourseList.data[key], 'name': key}
        this.data_F.push(item)
        this.data_F_List.push(item)
      }

      // 获取课程详细数据，并根据 showCourseStat 参数处理
      if (this.showCourseStat) {
        let courseDetailRes = await queryCourseCountDetailApi(param)
        this.courseDetailList = courseDetailRes.data || []
      } else {
        // 不显示课程统计数据，设为空数组
        this.courseDetailList = []
      }

      // Chart_G 图表数据
      let IpList = await queryExamIpAddressApi(param)

      if (!IpList.data) {
        IpList.data = []
      }

      if (IpList.data.length > 0) {
        this.data_G = IpList.data
      }
      let new_data_G = []
      this.data_G.map((e, i)=>{
        if (e.screenExamIpCountList.length > 6) {
          let arr = e.screenExamIpCountList
          arr = division(arr, 6)
          arr.map(val=>{
            let item = {
              placeName: e.placeName,
              screenExamIpCountList: [...val],
              short: true
            }
            new_data_G.push(item)
          })
        } else {
          e.short = false
          new_data_G.push(e)
        }
      })
      this.data_G = [...new_data_G]

      // E-charts 首次加载
      if (this.start_ECharts) {
        this.start_ECharts = !this.start_ECharts
        this.ScrollList = this.data_B_ImgList
        this.DrawECharts()
      }

      // 初始化课程轮播（只在课程数据变化时重新初始化）
      const newCourseListJson = JSON.stringify(this.courseDetailList)
      if (this.lastCourseListJson !== newCourseListJson) {
        this.lastCourseListJson = newCourseListJson
        this.initCourseBroadcast()
      }
    }

  },

  created(){
    let that = this
    // 读取路由参数，判断是否显示课程统计数据
    this.showCourseStat = this.$route.query.showCourseStat === 'true'
    // 基本数据刷新
    this.getPlanSession()
    clearInterval(this.timer_ps)
    this.timer_ps = setInterval(() => {
      that.getPlanSession()
    }, 30000)
  },

  mounted() {
    let that = this
    this.currentDate()
    this.getCustomSet()
    // E-charts 数据刷新
    // this.initECharts()
    clearInterval(this.timer_Int)
    this.timer_Int = setInterval(() => {
      that.initECharts()
    }, 5000)
    // 实时拍照播报 ==> 更新
    clearInterval(this.ImageTimer)
    this.ImageTimer = setInterval(() => {
      that.ScrollList = [...that.data_B_ImgList]
    }, 60000)
  },

  // 销毁定时器
  beforeDestroy() {
    clearInterval(this.timer_Int)
    clearInterval(this.timer_ps)
    clearInterval(this.Interval_A)
    clearInterval(this.Interval_B)
    clearInterval(this.Interval_C)
    clearInterval(this.Interval_D)
    clearInterval(this.Interval_E)
    clearInterval(this.Interval_F)
    clearInterval(this.Interval_G)
    clearInterval(this.Interval_H)
    clearInterval(this.currentTime)
    clearInterval(this.ImageTimer)
    // 清除课程轮播定时器
    if (this.courseBroadcastTimer) {
      clearInterval(this.courseBroadcastTimer)
      this.courseBroadcastTimer = null
    }
    // 销毁 ECharts 实例
    if (this.chart_C_instance) {
      this.chart_C_instance.dispose()
      this.chart_C_instance = null
    }
    if (this.chart_D_instance) {
      this.chart_D_instance.dispose()
      this.chart_D_instance = null
    }
  }
};
</script>
<style scoped lang="less">
.Data_V_Border {
  width: 100vw;
  height: 100%;
  background: #00134D;
}

#Data_V {
  .c1 {
    color: #FFA63E;
  }
  .c2 {
    color: #00D86C;
  }
  .c3 {
    color: #EE423D;
  }

  width: 100vw;
  height: calc(108/198 * 10rem);
  padding: 0 0.12rem 0.12rem;
  box-sizing: border-box;
  background: #00134D;
  display: flex;
  flex-direction: column;

  // Logo + Title + Date
  .Title {
    font-size: .18rem;
    font-weight: 600;
    line-height: .45rem;
    text-align: center;
    color: #FFF;
    height: calc((90/1080) * 100%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'PingFangSC-Semibold, PingFang SC';

    &>img {
      float: left;
      height: .18rem;
    }

    &>.Date {
      &>span:first-child {
        font-size: 0.08rem;
        font-weight: 400;
        color: rgba(255,255,255,0.85);
        margin-right: .06rem;
        font-family: 'PingFangSC-Regular, PingFang SC';
      }

      &>span:last-child {
        font-size: .1rem;
        font-weight: 600;
        color: #FFF;
        font-family: 'PingFangSC-Semibold, PingFang SC';
      }

    }
  }

  // Top
  .Top {
    background: #0F1D66;
    border-radius: .03rem;
    padding: .12rem .1rem;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: .08rem;

    .Top_title {
      display: flex;
      align-items: center;
      margin-bottom: .18rem;
      font-family: 'PingFangSC-Medium, PingFang SC';
      box-sizing: border-box;
      position: relative;

      .title_A {
        width: .03rem;
        height: .1rem;
        margin-right: 0.03rem;
        background: #266EFF;
        border-radius: .03rem;
        border-right: 0;
      }

      .title_B {
        font-size: .11rem;
        font-weight: 500;
        line-height: .12rem;
        color: #FFF;
      }

      .dit,.dit_B,.dit_C {
        width: .06rem;
        height: .06rem;
        border-radius: 50%;
        margin-left: .13rem;
        margin-right: .05rem;
        &>div {
          width: .03rem;
          height: .03rem;
          border-radius: 50%;
          opacity: 1;
          margin: .014rem auto;
        }
      }
      .dit {
        background: rgba(255, 166, 62, 0.3);
        &>div {
          background: #FFA63E;
        }
      }
      .dit_B {
        background: rgba(0, 216, 108, 0.3);
        &>div {
          background: #00D86C;
        }
      }
      .dit_C {
        background: rgba(238, 66, 61, 0.3);
        &>div {
          background: #EE423D;
        }
      }


      .title_C {
        // color: #00D86C;
        font-size: .11rem;
        font-weight: 500;
        line-height: .16rem;
        margin-right: .12rem;
      }

      .title_D {
        color: #A3A7BF;
        font-size: .08rem;
        line-height: 24px;
        &>span:last-child {
          font-size: .12rem;
        }
      }

      .title_E {
        position: absolute;
        right: 0;
        color: #A3A7BF;
        font-size: .08rem;
      }

    }

    .Top_main {
      width: 100%;
      height: .44rem;
      display: flex;
      justify-content: space-between;

      .item {
        width: 1.02rem;
        height: 100%;
        box-sizing: border-box;
      }

      // 进度条类型
      .item_A,.item_B,.item_C {
        display: flex;
        flex-wrap: wrap;
        padding-left: .06rem;
        padding-right: .26rem;
        box-sizing: border-box;

        .item_dule {
          width: 100%;
          height: .22rem;
          display: flex;
          justify-content: space-between;
          align-items: center;

          &>div:first-child {
            font-size: .08rem;
            font-weight: 400;
            color: #A3A7BF;
            font-family: 'PingFangSC-Medium, PingFang SC';
          }

          &>div:last-child {
            font-size: .18rem;
            font-weight: 500;
            color: #EE423D;
            font-family: 'DIN-Medium, DIN';
          }

        }

        .dule {
          width: 100%;
          height: .04rem;
          display: flex;

          .dule_item {
            width: .065rem;
            height: .04rem;
            margin-right: 1px;
            background: #27357E;
            opacity: 0.8;
          }

          .dule_item:first-child {
            border-radius: 50% 0px 0px 50%;
          }

          .dule_item:last-child {
            margin: 0;
            border-radius:  0px 50% 50% 0px;
          }

        }
      }

      .item_B .item_dule div:last-child {
        color: #FFA63E;
      }

      .item_C .item_dule div:last-child {
        color: #00D86C;
      }

      .item_D {
        border-left: 1px solid rgba(255,255,255,0.12);
        .item_dule {
          text-align: center;
          &>span {
            color: #FFF;
          }
          &>span:first-child {
            font-size: .18rem;
            font-family: 'DIN-Medium, DIN';
            font-weight: 500;
            line-height: .22rem;
            margin-right: .02rem;
          }
          &>span:last-child {
            font-size: .08rem;
            line-height: 22px;
            color: #A3A7BF;
            font-family: 'PingFangSC-Regular, PingFang SC';
          }
        }
        .item_des {
          text-align: center;
          font-size: .08rem;
          font-family: 'PingFangSC-Regular, PingFang SC';
          font-weight: 400;
          color: #A3A7BF;
          line-height: .12rem;
        }
      }

      .item_D:first-child {
        border: none;
      }

    }
  }

  // Main
  .DataV_main {
    width: 100%;
    // height: calc(776/1080 * 100%);
    height: calc(4/5 * 100%);
    display: flex;
    
    .Left,.Center {
      margin-right: .08rem;
    }

    .Left,.Center,.Right {
      .A,.B,.C {
        position: relative;
        background: #0F1D66;
        border-radius: .03rem;
        overflow: hidden;

        .title {
          width: 100%;
          padding-top: 24px;
          padding-left: 20px;
          padding-right: 24px;
          box-sizing: border-box;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-family: 'PingFangSC-Medium, PingFang SC';
          &>div {
            display: flex;
            align-items: center;
            .title_A {
              width: .03rem;
              height: .1rem;
              margin-right: 0.03rem;
              background: #266EFF;
              border-radius: .03rem;
              border-right: 0;
            }
            .title_B {
              font-size: .11rem;
              font-weight: 500;
              line-height: .12rem;
              color: #FFF;
            }
          }
          .title_C {
            font-size: .08rem;
            color: #A3A7BF;
            font-family: 'PingFangSC-Regular, PingFang SC';
            line-height: .12rem;
            float: right;
          }
        }

      }
    }

    .Left {
      width: 3.43rem;
      flex: 17;
      .A {
        width: 100%;
        height: calc(50% - .04rem);

        #chart_A {
          width: 100%;
          height: 100%;
          padding-top: .24rem;
          box-sizing: border-box;
        }
        .strate {
          width: 100%; 
          height: 20px; 
          box-sizing: border-box; 
          position: absolute;
          top:.3rem;
          display: flex;
          justify-content: space-around;
          padding: 0 .9rem;
          &>div {

            display: flex;
            align-items: center;

            div {
              width:.06rem; 
              height:.04rem;
              border-radius:2px;
            }

            span {
              color: #A3A7BF;
              margin-left: .03rem;
              font-size: 14px;
              font-family: 'PingFangSC-Regular, PingFang SC';
            }
          }

        } 
      }
      .B {
        width: 100%;
        margin-top: .08rem;
        height: calc(50% - .04rem);
        .Scroll {
          width: 100%;
          height: 1.55rem;
          position: absolute;
          bottom: 0;
          padding: .0rem .15rem .075rem;
          box-sizing: border-box;
          overflow: hidden;
          .VueScoll {
            height: 100%; 
            overflow: hidden;
            ul li {
              height: .35rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: .09rem;
              font-family: 'PingFangSC-Regular, PingFang SC';
              border-bottom: 1px dashed rgba(255,255,255,0.15);
              color: rgba(255,255,255,0.85);
              .A {
                color: #FFF;
                opacity: .85;
                width: .7rem;
              }
              .B {
                color: rgba(255,255,255,0.85);
                width: .9rem;
                text-align: left;
                margin: 0;
              }
              .C {
                color: rgba(255,255,255,0.85);
                width: .9rem;
                text-align: left;
              }
              .D {
                color: rgba(255,255,255,0.85);
                width: .54rem;
                text-align: right;
              }
              .B,.C,.D {
                &>span {
                  font-size: .1rem;
                  font-family: 'PingFangSC-Medium, PingFang SC';
                  font-weight: 500;
                  color: #FFF;
                  opacity: 1;
                }
              }

            }
            .ImgScroll {
              li {
                height: .56rem;
                margin-bottom: .05rem;
                display: flex;
                justify-content: left;
                &>div {
                  margin-right: .05rem;
                }

                &>div:last-child {
                  margin-right: 0;
                }

                &>div {
                  height: .56rem; 
                  width: .75rem; 
                  overflow: hidden; 
                  display: flex;
                  justify-content: center;
                  position: relative;
                  border-radius: 4px;
                  &>img {
                    width: 100%;
                  }
                  &>div {
                    width: 100%; 
                    height: .12rem; 
                    position: absolute; 
                    background: rgba(0,0,0,0.75);
                    bottom: 0; 
                    display: flex; 
                    align-items: center;
                    padding-left: .04rem;
                    box-sizing: border-box;
                    &>div:first-child {
                      width: .03rem;
                      height: .03rem;
                      border-radius: 50%;
                      background: red;
                    }
                    &>div:last-child {
                      margin-left: .03rem;
                      font-size: .07rem;
                      font-family: 'PingFangSC-Regular, PingFang SC';
                      color: #FFFFFF;
                      line-height: .12rem;
                    }
                  }
                }
              }
            }
          }
        }


      }
    }

    .Center {
      width: 3.43rem;
      flex: 17;
      .A {
        width: 100%;
        height: calc(50% - .04rem);
        .charts {
          width: 100%;
          height: 100%;
          position: relative;
          padding-top: .42rem;
          box-sizing: border-box;

          .chart_C,.chart_D {
            position: absolute;
            top: 0;
            width: 50%;
            height: 100%;
            box-sizing: border-box;
            padding-top: .42rem;
            // padding-bottom: .25rem;

            .chart_Border_C,.chart_Border_D {
              width: .9rem;
              height: .9rem;
              border: 1px solid transparent;
              margin: 0 auto;
              #chart_C_ID,#chart_D_ID {
                width: 100%;
                height: 100%;
              }
            }

            .info_Mob,.info_Web {
              width: .9rem;
              height: .12rem;
              color: #FFF;
              font-size: .07rem;
              font-family: 'PingFangSC-Regular, PingFang SC';
              display: flex;
              align-items: center;
              margin: 0 auto;
              margin-top: .11rem;
              padding-left: .16rem;
              box-sizing: border-box;
              .dit {
                display: inline-block;
                width: .04rem;
                height: .04rem;
                margin-right: .04rem;
                border-radius: 50%;
                background: #00CC88;
              }

              .number {
                margin: 0 .04rem;
                font-size: .09rem;
                font-weight: 500;
                font-family: 'Futura-Medium, Futura';
              }

            }

            .info_Web {
              margin-top: .06rem;
              .dit {
                background: #FFA63E;
              }
            }
          }
          .chart_D {
            left: 50%;
            .info_Mob {
              .dit {
                background: #EE423D;
              }
            }

            .info_Web {
              .dit {
                background: #00CC88;
              }
            }


          }
          // 课程列表样式
          .courseList {
            position: absolute;
            top: .40rem;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 0 .1rem;
            box-sizing: border-box;
            overflow: hidden;

            .course-item {
              margin-top: 2px;

              &:last-child {
                margin-bottom: 0;
              }

              .course-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: .06rem ;
                padding-top: 20px;
                background: rgba(255, 255, 255, 0.05);
                border-radius: 4px;
                margin-bottom: 15px;

                &:last-child {
                  margin-bottom: 0;
                }

                .course-name {
                  font-size: 16px ;
                  color: #FFF;
                  font-family: 'Futura-Medium, Futura';
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: block;
                  width: 30%;
                  font-weight: 500;
                }

                .course-data { 
                  flex: 1;
                  display: block;
                  justify-content: space-around;
                  width: 69%;

                  .data-row {
                    display: block; 
                    width: 100%;
                    height: auto;
                    align-items: center;
                    font-size: .07rem;
                    font-family: 'PingFangSC-Regular, PingFang SC';

                    &.examed-row {
                      color: rgba(255, 255, 255, 0.85);

                      .label{ 
                        color: rgba(255, 255, 255, 0.85);
                        display: block; float: left;height: 35px;
                        font-size: 16px;
                        font-family: 'Futura-Medium, Futura';
                        font-weight: 400;
                        span.unexamed{ color: rgb(247, 157, 2);}
                        span.examed{ color: rgb(235, 247, 246);}
                        span.percent{ color: rgb(235, 247, 246);}
                      }
                    } 

                    &.abnormal-row {
                      color: rgba(255, 255, 255, 0.85);
                      margin-top: 20px;

                      .label{ 
                        color: rgba(255, 255, 255, 0.85);
                        display: block; float: left; height: 35px;
                        font-size: 16px;
                        font-family: 'Futura-Medium, Futura';
                        font-weight: 400;
                        span.normal{ color: rgb(235, 247, 246);}
                        span.abnormal{ color: rgb(247, 157, 2);}
                        span.percent{ color: rgb(247, 157, 2);}
                      } 
                    }

                    .label {
                      color: rgba(255, 255, 255, 0.6);
                    }
                  }
                }
              }
            }
          }
        }

      }
      .B {
        width: 100%;
        height: calc(50% - .04rem);
        margin-top: .08rem;
        #chart_B {
          width: 100%;
          height: calc(100% - 20px);
          padding-top: .24rem;
          box-sizing: border-box;
        }
      }
    }

    .Right {
      width: 2.42rem;
      flex: 12;
      .A {
        width: 100%;
        height: calc(26/78 * 100%);

        .chart_E {
          margin-top: .34rem;
          width: 100%;
          height: calc(100% - .34rem);
          box-sizing: border-box;
          display: flex;

          #chart_E {
            width: 90%;
            height: 90%;
          }

          .des {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;
            padding: .19rem 0;
            box-sizing: border-box;

            .des_item:first-child {
              .dit {
                background: #023AFF;
              }
            }

            .des_item:nth-child(2) {
              .dit {
                background: #00D86C;
              }
            }

            .des_item:last-child {
              .dit {
                background: #EE423D;
              }
              .des_num {
                &>span {
                  color: #EE423D;
                }
              }
            }

            .des_item {
              width: 100%;
              display: flex;
              align-items: center;
              padding-left: .16rem;
              box-sizing: border-box;

              .dit {
                width: .04rem;
                height: .04rem;
                border-radius: 50%;
                margin-right: .04rem;
              }
              .des_step {
                width: .4rem;
                height: .12rem;
                margin-right: .06rem;
                color: #FFF;
                font-size: .07rem;
                font-family: 'PingFangSC-Regular, PingFang SC';
                line-height: .12rem;
              }
              .des_num {
                color: #FFF;
                line-height: .12rem;
                font-family: 'PingFangSC-Regular, PingFang SC';
                &>span {
                  font-size: .09rem;
                  margin-right: .01rem;
                  font-weight: 500;
                  font-family: 'Futura-Medium, Futura';
                }
              }
            }
          }
        }
      }
      .B {
        width: 100%;
        margin-top: .08rem;
        height: calc(26/78 * 100%);

        .charts_desc {
          width: 50%;
          height: calc(100% - .34rem);
          margin-top: .28rem;
          margin-left: -.1rem;
          ul {
            display: flex;
            flex-wrap: wrap;
            align-items: space-around;
          }
          ul li {
            display: flex; 
            align-items: center; 
            width: 100%;
            box-sizing: border-box;
            margin-top: .03rem;
            font-family: 'PingFangSC-Regular, PingFang SC';

            &>div {
              width: .04rem; 
              height: .04rem; 
              border-radius: 50%;
            }

            &>span {
              color: #FFF;
              margin-left: .04rem;
            }

            .itemA {
              display: inline-block;
              min-width: .34rem;
              width: auto;
            }

            .itemB {
              font-family: 'Futura-Medium, Futura';
              display: inline-block;
              width: .16rem;
              text-align: right;
            }

          }
        }

        .charts {
          margin-top: .34rem;
          width: 50%;
          height: calc(100% - .34rem);
          box-sizing: border-box;
          display: flex;
          margin-left: .08rem;
          #chart_F {
            width: 90%;
            height: 90%;
          }
        }

      }
      .C {
        width: 100%;
        margin-top: .08rem;
        height: calc(226/780 * 100%);

        .title {
          &>div {
            .title_B {
              &>span {
                font-size: .08rem;
                color: #A3A7BF;
              }
            }
          }
        }

        #chart_G {
          padding-top: .16rem;
          box-sizing: border-box;
          width: 100%;
          height: 100%;
        }

      }
    }

  }
}
</style>